import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Container from '../../common/components/Container/Container';
import Loading from '../../common/components/Loading/Loading';
import useZendeskWidget, { updateOptions, ZendeskUserEventAction } from '../../common/hooks/useZendeskWidget';
import { Resolver } from '../../config';
import { MetadataContext } from '../../providers/MetadataContext';
import { mapZendeskFieldsFromMetadata } from './SupportUtils';
import Log from '../../common/logging';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function ZendeskSupportScreen(): JSX.Element {
  const navigate = useNavigate();
  const { metadata } = useContext(MetadataContext);
  const location = useLocation();
  const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);
  const { zendeskWidget } = Resolver.getServiceConfig();

  useEffect(() => {
    if (!scriptLoaded) {
      return;
    }

    const prefilledFields = mapZendeskFieldsFromMetadata(metadata, zendeskWidget);
    Log.debug(`Updating zendesk pre-filled fields: ${JSON.stringify(prefilledFields, null, 2)}`);
    updateOptions({
      prefilledFields,
    });
  }, [metadata, scriptLoaded]);

  const handleLoaded = () => {
    zE.activate();
    setScriptLoaded(true);
  };

  const handleUserEvent = (action: ZendeskUserEventAction) => {
    if (action === ZendeskUserEventAction.FormSubmitted || action === ZendeskUserEventAction.WidgetMinimised) {
      navigate(-1);
    }
  };

  useZendeskWidget(zendeskWidget.key, {
    onUserEvent: handleUserEvent,
    onWidgetLoaded: handleLoaded,
    prefilledFields: [
      { id: zendeskWidget.fieldsId.did, value: 'did' },
      { id: zendeskWidget.fieldsId.flowId, value: '' },
      { id: zendeskWidget.fieldsId.screenId, value: location.state?.from },
      { id: zendeskWidget.fieldsId.validationId, value: 'unknown' },
    ],
  });

  return (
    <Container iframeContainerCssClass="recaptcha-container" verticalPadding="py-48">
      <div className="flex-row justify-center items-center h-full" data-testid="CONTACT_SUPPORT">
        <Loading />
      </div>
    </Container>
  );
}
export default withRouteAnalytics(ZendeskSupportScreen, Screens.ZENDESK_SUPPORT);
